(() => {
  if (window.__olouiooSignatureMenuSyncLoaded) return;
  window.__olouiooSignatureMenuSyncLoaded = true;
  const requests = new WeakMap(), selections = new WeakMap();
  const priceText = value => new Intl.NumberFormat(document.documentElement.lang || 'en-AU', { style:'currency', currency:window.Shopify?.currency?.active || 'AUD' }).format(value / 100);
  const text = (node, value) => { if (node && node.textContent !== value) node.textContent = value; };
  const selectedOptions = picker => {
    const options = [...picker.querySelectorAll('[data-signature-option]:checked')].map(input => ({ position:Number(input.dataset.optionPosition), value:input.value }));
    const finish = picker.querySelector('[data-signature-finish]:checked'), linen = picker.querySelector('[data-signature-linen]:checked');
    if (finish && linen) options.push({ position:1, value:`${finish.value} · ${linen.value}` });
    return options;
  };
  function syncLinenImage(picker) {
    const linen = picker.querySelector('[data-signature-linen]:checked'), scope = picker.closest('.product-information');
    if (!linen?.dataset.linenImage || !scope) return;
    const source = new URL(linen.dataset.linenImage,location.href).href;
    for (const image of scope.querySelectorAll('[data-coupe-gallery] img, sticky-add-to-cart .sticky-add-to-cart__media img')) {
      if (image.src !== source) { image.removeAttribute('srcset'); image.src = source; }
      if (image.alt !== linen.value) image.alt = linen.value;
    }
  }
  function updateSummary(picker, product, variant, formComponent) {
    const guests = picker.querySelector('[data-signature-guests]:checked');
    const allowance = picker.querySelector('[data-signature-allowance]');
    if (guests && allowance) text(allowance,String(Number(guests.value.match(/\d+/)?.[0]) * (product.handle.includes('-signature-collection') ? 2 : 1)));
    const enquiry = picker.querySelector('[data-signature-enquiry]');
    if (enquiry) {
      const url = new URL(enquiry.dataset.baseUrl,location.origin);
      url.searchParams.set('service',product.title);
      url.searchParams.set('service_handle',product.handle);
      if (enquiry.dataset.countBasis === 'drinks') url.searchParams.set('drink_count',enquiry.dataset.countRequest);
      else url.searchParams.set('guest_tier',`More than ${enquiry.dataset.guestLimit || 110} guests`);
      url.searchParams.set('finish',picker.querySelector('[data-signature-finish]:checked, [data-option-position="1"]:checked')?.value || '');
      url.searchParams.set('linen',picker.querySelector('[data-signature-linen]:checked')?.value || '');
      url.searchParams.set('drinks',picker.querySelector('[data-option-position="3"]:checked')?.value || '');
      enquiry.href = url.href;
    }
    const scope = picker.closest('.product-information');
    for (const input of scope?.querySelectorAll('product-form-component input[name="id"],sticky-add-to-cart select[name="id"]') || []) {
      if (input.closest('product-form-component')?.dataset.productId && String(input.closest('product-form-component').dataset.productId) !== String(product.id)) continue;
      input.value = String(variant.id);
      if (input.matches('input')) input.setAttribute('value',String(variant.id));
    }
    text(picker.querySelector('[data-signature-price]'),priceText(variant.price) + ' ' + (window.Shopify?.currency?.active || 'AUD'));
    scope?.querySelectorAll(`product-price[data-product-id="${product.id}"] .price-container > .price`).forEach(node => text(node,priceText(variant.price)));
    const duration = window.OlouiooDuration?.cost(formComponent) || 0;
    const quantity = Math.max(1,Number(formComponent.querySelector('[name="quantity"]')?.value) || 1);
    text(formComponent.querySelector('.add-to-cart-price'),' - ' + priceText(variant.price * quantity + duration));
    const pageUrl = new URL(location.href);
    pageUrl.searchParams.set('variant',String(variant.id));
    if (pageUrl.href !== location.href) history.replaceState({},'',pageUrl);
  }
  async function refreshDesktopSection(picker, owner, product, variant, controller) {
    if (product.handle === 'la-coupe-welcome-toast-table' || matchMedia('(max-width:749px)').matches || !owner.dataset.sectionId) return;
    const url = new URL(owner.dataset.productUrl,location.origin);
    url.searchParams.set('variant',String(variant.id));
    url.searchParams.set('section_id',owner.dataset.sectionId);
    try {
      const response = await fetch(url,{ signal:controller.signal, cache:'no-store' });
      if (!response.ok || controller.signal.aborted) return;
      const html = new DOMParser().parseFromString(await response.text(),'text/html');
      if (controller.signal.aborted) return;
      const scope = picker.closest('.product-information');
      const price = scope?.querySelector(`product-price[data-product-id="${product.id}"]`), nextPrice = html.querySelector(`product-price[data-product-id="${product.id}"]`);
      if (price && nextPrice) price.innerHTML = nextPrice.innerHTML;
      const gallery = scope?.querySelector('media-gallery'), nextGallery = html.querySelector('media-gallery');
      if (gallery && nextGallery) gallery.replaceWith(nextGallery);
    } catch {}
  }
  async function syncPicker(picker) {
    syncLinenImage(picker);
    const owner = picker.closest('product-form-component'), input = picker.querySelector('[data-signature-variant]'), error = picker.querySelector('[data-signature-error]');
    const options = selectedOptions(picker), key = JSON.stringify(options);
    if (!owner || !input || !options.length || (selections.get(picker) === key && picker.dataset.variantPending === 'false')) return;
    requests.get(picker)?.abort();
    const controller = new AbortController();
    requests.set(picker,controller);
    picker.dataset.variantPending = 'true';
    const notify = (status,variant) => picker.dispatchEvent(new CustomEvent('olouioo:service-variant',{ bubbles:true, detail:{ productId:owner.dataset.productId,status,variant } }));
    notify('pending');
    if (error) error.hidden = true;
    try {
      const {fetchProduct} = await import('@theme/variant-selection');
      const product = await fetchProduct(owner.dataset.productUrl,owner.dataset.productId);
      if (controller.signal.aborted) return;
      const complete = product.options.map((_,index) => {
        const explicit = options.find(choice => choice.position === index + 1);
        if (explicit) return explicit.value;
        const values = [...new Set(product.variants.map(item => item.options[index]))];
        return values.length === 1 ? values[0] : null;
      });
      const variant = product.variants.find(item => item.options.length === complete.length && item.options.every((value,index) => value === complete[index]));
      if (!variant?.available) throw new Error('This combination is unavailable. Choose another option.');
      updateSummary(picker,product,variant,owner);
      input.value = String(variant.id);
      input.setAttribute('value',String(variant.id));
      selections.set(picker,key);
      picker.dataset.variantPending = 'false';
      notify('ready',variant);
      await refreshDesktopSection(picker,owner,product,variant,controller);
    } catch (failure) {
      if (controller.signal.aborted || failure.name === 'AbortError') return;
      input.value = '';
      input.setAttribute('value','');
      if (error) { error.textContent = failure.message || 'Unable to select this package.'; error.hidden = false; }
      picker.dataset.variantPending = 'false';
      notify('error');
    } finally {
      if (requests.get(picker) === controller) requests.delete(picker);
    }
  }
  document.addEventListener('variant:update',event => {
    const picker = event.target.closest?.('.product-information')?.querySelector('signature-menu-picker');
    if (picker) queueMicrotask(() => syncPicker(picker));
  });
  const initialise = () => document.querySelectorAll('signature-menu-picker').forEach(picker => syncPicker(picker));
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded',initialise,{once:true});
  else initialise();
  document.addEventListener('change',event => {
    const picker = event.target.closest?.('signature-menu-picker');
    if (picker && event.target.matches('[data-signature-option],[data-signature-finish],[data-signature-linen]')) syncPicker(picker);
  },true);
})();
